export const trackUserPreferenceCCPA = () => {
    fetch(
        `https://pubads.g.doubleclick.net/activity;dc_iu=/23171577/DFPAudiencePixel;ord=${Math.random()};dc_seg=907193633`,
        {mode: 'no-cors'})
    .catch(err => err);
};
